import React from "react";
import documentoPDF from "../../assets/Uso_JChessManager.pdf";
import { Button } from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const DescargarPDF = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = documentoPDF;
    link.download = "Uso_JChessManager.pdf.pdf";
    link.click();
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<PictureAsPdfIcon />}
      onClick={handleDownload}
    >
      Descargar PDF
    </Button>
  );
};

export default DescargarPDF;
